export enum PcVersionEnum {
  false,
  true,
}
export interface IHomeDetail {
  /** 是否开启PC版首页,0未开启，1已开启 */
  isOpenPcVersion: number
  /** 首页ID */
  pageId: string
  /** 首页名称 */
  pageName: string
}
export interface IHome {
  body: IHomeDetail[]
  code: number
  message: string
}
